import { JSConn } from "@/utilities/js-conn";
import Vue from "vue";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import { GrindingLoad } from "@/store/modules/grindingLoads";

export default Vue.extend({
  name: "grindingLoads",
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Grinding Loads...",
      sortBy: "client",
      filter: "",
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "client", label: "Client", sortable: true },
        { key: "total_tons", label: "Tons", sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    grindingLoads(): GrindingLoad[] {
      return this.$store.getters.grindingLoadsForTable;
    },
  },
  created() {
    const jsConn = new JSConn();
    this.$store.dispatch("needGrindingLoads", jsConn).then(() => {
      this.dataLoaded = true;
    });
  },
});
